<app-site-layout
  [filtersTpl]="filtersTpl"
  [leftControlsTpl]="leftControlsTpl"
  [rightControlsTpl]="rightControlsTpl"
  [contentTpl]="contentTpl"
  [companyId]="companyId"
  [pageRangeInfo]="pageRangeInfo$ | async"
  [adjustContentHeight]="mode !== Modes.TABLE"
></app-site-layout>

<ng-template #filtersTpl>
  <app-models-table-filters class="filters_component"></app-models-table-filters>
</ng-template>

<ng-template #leftControlsTpl>
  <app-sites-add-buttons [companyId]="companyId"></app-sites-add-buttons>
</ng-template>

<ng-template #rightControlsTpl>
  <app-actions-buttons
    *ngIf="mode === Modes.TABLE"
    (archive)="archive()"
    (delete)="delete()"
    [disabled]="!selectedEntities.length"
    [archiveButtonLabel]="showArchived ? 'Unarchive models' : 'Archive models'"
    deleteButtonLabel="Delete models"
  ></app-actions-buttons>
  <button
    nbButton
    ghost
    size="tiny"
    class="sites-nav__favorites-toggle"
    [class.sites-nav__favorites-toggle--active]="showFavorites"
    data-testId="favorites-filter-toggle"
    [nbTooltip]="showFavorites ? 'Show all models' : 'Show favorites only'"
    (click)="changeFavoriteSelect(!showFavorites)"
  >
    <nb-icon [icon]="showFavorites ? 'star' : 'star-outline'"></nb-icon>
  </button>
  <app-archive-mode-select
    *ngIf="hasPermission(permissions.CAN_ACCESS_ARCHIVED_MODELS)"
    [showArchived]="showArchived"
    (archiveChange)="changeArchiveSelect($event)"
  ></app-archive-mode-select>
</ng-template>

<ng-template #contentTpl>
  <nb-tabset (changeTab)="onChangeTab($event)" class="models_site__tabset">
    <nb-tab
      [tabId]="Modes.TABLE"
      tabIcon="layout-outline"
      tabTitle="Table"
      [active]="mode === Modes.TABLE"
    >
      <app-models-table></app-models-table>
    </nb-tab>
    <nb-tab
      [tabId]="Modes.GRID"
      tabIcon="grid-outline"
      tabTitle="Grid"
      [active]="mode === Modes.GRID"
    >
      <app-models-grid></app-models-grid>
    </nb-tab>
    <nb-tab [tabId]="Modes.MAP" tabIcon="map-outline" tabTitle="Map" [active]="mode === Modes.MAP">
      <app-models-map></app-models-map>
    </nb-tab>
  </nb-tabset>
</ng-template>
